<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    @font-face {
        font-family: 'regularMontserratFont';
        src: url('./assets/fonts/montserrat-light.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldMontserratFont';
        src: url('./assets/fonts/montserrat-medium.ttf') format('truetype');
        font-weight: bold;
    }

    body {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
    }

    .application {
        font-family: regularFont;
        background: transparent !important;
        font-size: 14px;
    }

    .swal2-container {
        font-family: regularFont;
    }

    .text-bold {
        font-family: boldFont;
    }

    .container {
        padding: 20px !important;
        height: 100%;
    }

    .app-body {
        max-width: 500px;
        margin: 0 auto;
    }

    .app-footer {
        max-width: 500px;
        margin-left: auto !important;
        margin-right: auto !important;
    }

    button {
        font-family: boldFont;
        text-transform: initial !important;
    }

    button:not(.radius-inline) {
        border-radius: 25px !important;
    }

    a {
        text-decoration: underline;
    }

    .app-container {
        padding: 0 20px !important;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
        overflow-x: hidden;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }

    .app-title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 5px;
    }

    .app-subtitle {
        font-size: 16px;
        text-align: center;
    }

    .app-info {
        padding: 20px 0;
        text-align: center;
    }

    .app-label-selected {
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-bottom: 20px;
    }

    .app-label-image-selected {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-bottom: 60px;
    }

    .app-label-image-selected img {
        height: 28px;
    }

    .app-video {
        text-align: center;
        padding: 20px 0 0;
    }

    .app-image {
        text-align: center;
        padding: 40px 0 20px;
    }

    .app-image img {
        width: 200px;
        max-width: 100%;
    }

    .app-footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 10px 0 20px;
    }

    .app-footer>div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-footer button svg:first-child {
        margin-right: 7px;
    }

    .app-footer button {
        width: 100%;
        margin: 5px 0;
        font-size: 16px !important;
        height: 40px;
    }

    .app-margin-space {
        margin: 20px 0;
    }

    .form-row {
        padding: 5px 0;
        position: relative;
    }

    .form-row-label {
        padding: 5px 0 0;
    }

    .form-row-label .form-row-title {
        margin-bottom: 0 !important;
    }

    .form-row-title {
        margin-bottom: 5px;
        display: flex;
    }

    .form-row-title-parent {
        margin-bottom: 5px;
        display: flex;
        font-family: boldFont;
        font-size: 15px;
    }

    .form-row-photo-caption {
        margin: 15px 0 -5px;
        text-align: center;
    }

    .form-row .v-input:not(.form-row-mobile-phone-number):not(.input-theme-light) {
        padding: 0 !important;
        margin: 0 !important;
    }

    .form-row .v-input.form-row-mobile-phone-number {
        padding: 0 0 0 98px !important;
        margin: 0 !important;
    }

    .form-row>div:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) {
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) .v-input__control {
        margin: 0 !important;
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) .v-input__slot {
        margin: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .form-row .v-input:not(.input-theme-light) .v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-text-field--outline>.v-input__control>.v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-select--chips .v-input__slot {
        padding: 5px !important;
    }

    .form-row .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) input {
        margin: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
    }

    .form-row .v-input:not(.v-textarea):not(.multiselect-search):not(.v-select--chips):not(.form-row-field-buttons):not(.form-row-field-slider-horizontal):not(.form-row-datepicker-inline):not(.tags-input-root):not(.v-input--radio-group) .v-input__append-inner {
        margin-top: 7px !important;
    }

    .form-row .v-input--radio-group .v-input__slot {
        border-radius: 4px;
        padding: 10px;
    }

    .form-row textarea {
        padding: 12px;
        min-height: 100px;
    }

    .select-search-title {
        justify-content: center;
        font-family: boldFont;
        padding-bottom: 0;
    }

    .select-search-list-search {
        font-size: 14px;
    }

    .select-search-list {
        height: 55vh;
        overflow: auto;
    }

    .select-search-list>div {
        cursor: pointer;
        padding: 5px;
    }

    .select-search-list-center>div {
        justify-content: center;
    }

    .select-search-list>div.active {
        background-color: #ddd;
        border-radius: 5px;
    }

    .form-row-field-textarea-large {
        height: 180px;
    }

    .form-row .v-autocomplete .v-select__slot>input {
        pointer-events: none !important;
    }

    .form-row .v-select__selections {
        padding: 0 !important;
    }

    .form-row .v-select__selection--comma {
        margin: 0 !important;
    }

    .form-row-input-password input {
        padding-right: 20px !important;
    }

    .form-row-password-icon {
        position: absolute;
        top: 40px;
        right: 10px;
        cursor: pointer;
        color: #888;
    }

    .form-row-mobile-phone-indicative {
        position: absolute;
        left: 0;
        bottom: 5px;
        width: 90px;
        z-index: 1;
    }

    .form-row-mobile-phone-indicative .v-input__slot {
        padding: 0 5px;
    }

    .form-row-field-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .form-row-field-buttons>div {
        flex: 50%;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .form-row-field-buttons>div:nth-child(odd) {
        justify-content: flex-end;
    }

    .form-row-field-buttons>div:nth-child(even) {
        justify-content: flex-start;
    }

    .form-row-field-button {
        width: 15vh;
        height: 15vh;
        opacity: 0.6;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .form-row-field-button-slider {
        width: 100%;
        height: 100%;
    }

    .form-row-field-button>img {
        height: 35%;
    }

    .form-row-field-button span {
        font-size: 20px;
        font-family: boldFont;
    }

    .form-row-field-button label {
        font-size: 20px;
    }

    .form-row-field-button>img {
        height: 35%;
    }

    .form-row-field-button-active {
        opacity: 1 !important;
    }

    .form-row-field-slider-horizontal {
        width: calc(100% - 4vh);
        margin: 0 auto;
    }

    .form-row-field-slider-horizontal .vueperslides__parallax-wrapper {
        pointer-events: none;
    }

    .form-row-field-slider-horizontal .vueperslides__arrow svg {
        width: 2.8em;
        stroke: #506860;
        outline: none;
        stroke-width: 1 !important;
    }

    .form-row-field-slider-horizontal .vueperslides__arrow--prev {
        left: -11.5% !important;
    }

    .form-row-field-slider-horizontal .vueperslides__arrow--next {
        right: -11.5% !important;
    }

    .form-row-field-slider-horizontal .vueperslide {
        transform: scale(0.8);
    }

    .form-row-field-slider-horizontal .vueperslide--active {
        transform: scale(1);
    }

    .v-dialog {
        margin: 0 auto !important;
    }

    .checkbox-container {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }

    .checkbox-container.disabled {
        pointer-events: none;
        opacity: 0.3;
    }

    .checkbox-container-box {
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 22px;
        height: 22px;
        border: 1px solid #fff;
        border-radius: 4px;
        font-size: 12px;
    }

    .v-select-list .v-list__tile__title {
        display: flex;
        white-space: initial;
        overflow: initial;
        height: auto;
        min-height: 24px;
    }

    .component-select-close {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px;
        margin: -10px 0;
        color: #888;
    }

    .app-buttons-flex {
        padding-top: 20px;
    }

    .app-buttons-flex>div {
        width: calc(50% - 20px);
        margin: 10px;
        height: 120px;
        font-family: boldFont;
        text-transform: initial;
        font-size: 18px;
        border-radius: 25px;
        cursor: pointer;
        text-align: center;
    }

    .app-buttons-flex-small>div {
        height: 60px;
        font-size: 12px;
    }

    .app-buttons-flex-buttons-background {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .app-buttons-flex-buttons-background>div {
        margin: 0 5px;
        padding: 10px;
        width: 19vh;
        height: 19vh;
        font-size: 13px;
    }

    .app-buttons-cols {
        display: flex;
        flex-wrap: wrap;
    }

    .app-buttons-cols-item {
        max-width: calc(50% - 10px);
    }

    .app-buttons-cols-item>div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 10px;
        padding: 5px;
    }

    .app-buttons-cols-item span {
        font-size: 18px;
    }

    .app-step-tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 0;
    }

    .app-step-tabs>div {
        padding: 5px 5px 0;
        width: 100%;
    }

    .app-step-tabs>div>div {
        width: 100%;
        border-bottom: 1px solid;
        text-align: center;
        padding-bottom: 5px;
    }

    .tags-input-wrapper-default {
        padding: 5px;
    }

    .tags-input-badge-selected-default {
        background-color: #e1e1e1;
        color: #555;
        padding: 8px 22px 8px 12px;
        font-size: 12px;
        margin: 2.5px !important;
    }

    .tags-input-remove:before,
    .tags-input-remove:after {
        background-color: #888;
    }

    .tags-input-remove {
        right: 6px;
        top: 7px;
        padding: 8px;
    }

    .tags-input-remove:before,
    .tags-input-remove:after {
        background-color: #888;
        background: #888;
    }

    .typeahead-badges {
        margin-bottom: 0;
    }

    .app-app-links {
        gap: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 0 40px;
    }

    .app-app-links > div {
        width: 100%;
        max-width: 200px;
    }

    .app-footer-message {
        text-align: center;
        padding-bottom: 20px;
    }

    .app-container-step-bottom {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .app-button-top-back {
        padding: 40px 0 5px;
        text-transform: lowercase;
        display: flex;
        align-items: center;
        font-size: 11px;
    }

    .app-button-top-back span {
        margin-top: -2px;
        margin-left: 5px;
    }

    .buttons-theme-small button {
        max-width: 250px;
    }

    .form-row-datepicker-inline {
        display: flex;
    }

    .form-row-datepicker-inline .vue-scroll-picker {
        margin: 0 10px;
    }

    .form-row-datepicker-inline .vue-scroll-picker-item {
        height: 30px;
        line-height: 30px;
    }

    .form-row-datepicker-inline .vue-scroll-picker-layer .top,
    .form-row-datepicker-inline .vue-scroll-picker-layer .bottom {
        border-color: #d0e5df;
    }

    /* Json classes */
    .app-container-adjust-content {
        height: 100%;
    }

    .app-container-adjust-content .app-content {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .app-container-adjust-content .app-body {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .app-container-adjust-content .app-body-div-container {
        width: 100%;
    }

    .app-container-adjust-content .app-margin-space {
        width: 100%;
    }

    .app-container-adjust-content .app-subscription-container {
        width: 100%;
    }

    .app-container-adjust-content .app-footer {
        width: 100%;
    }

    .app-container-step-background {
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 -20px;
        padding: 0 20px;
    }

    .input-theme-light {
        margin-bottom: 10px !important;
    }

    .input-theme-light .v-input__slot {
        border-width: 1px !important;
        font-size: 13px;
        background-color: transparent !important;
    }

    .input-theme-light .v-label {
        font-size: 13px;
        line-height: 13px;
        letter-spacing: 1px;
    }

    .input-theme-light .v-input__slot:before,
    .input-theme-light .v-input__slot:after {
        border-color: #d0e5df !important;
    }

    .input-theme-light .primary--text {
        color: rgba(0, 0, 0, .54) !important;
        caret-color: rgba(0, 0, 0, .54) !important;
    }

    .input-theme-light.v-textarea {
        border: 1px solid #d0e5df;
        border-radius: 15px;
        padding: 0;
    }

    .input-theme-light.v-textarea textarea {
        resize: none !important;
    }

    .input-theme-light.v-textarea .v-input__slot:before,
    .input-theme-light.v-textarea .v-input__slot:after {
        display: none;
    }

    .buttons-theme-light button {
        box-shadow: none !important;
    }

    .app-container-font-montserrat {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .form-row-title {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .application {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .swal2-container {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .text-bold {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-subtitle {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .app-info {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .app-label-selected {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat button {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-tabs>div {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-title {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-top {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-arrows-bottom {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row-title-parent {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row .input-slider-legend-value-circle {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-buttons-flex>div {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .form-row-field-buttons span {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .select-search-title {
        font-family: boldMontserratFont;
    }

    .app-container-font-montserrat .app-buttons-cols-item {
        font-family: regularMontserratFont;
    }

    .app-container-font-montserrat .app-buttons-cols-item span {
        font-family: boldMontserratFont;
    }
</style>

<script>
    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        beforeMount: function () {
            Utils.initialize()
        }
    }
</script>
